import React from 'react';

const ProductTitle = ({ record }) => {
	return <span>Product {record ? `"${record.name}"` : ''}</span>;
};

export default ProductTitle;
